import styled from 'styled-components';

export const HeaderText = styled.h1`
  color: white;
  margin: 20px 40px;
  font-size: 27px;
	font-weight: 400;
`;
